import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFlags } from '../hooks/useFlags';

/**
 * Wraps a route so it only renders when the `affiliatesEnabled` flag is true.
 * While the flag request is in flight we render null (not a loader) — the
 * request is very fast and showing a spinner on hidden routes would leak that
 * the feature exists. When the flag is false we redirect to `/` so deep links
 * to /helper/login, /affiliate etc. just silently fall back to home.
 */
const AffiliateOnly = ({ children }) => {
  const flags = useFlags();
  if (!flags._loaded) return null;
  if (!flags.affiliatesEnabled) return <Navigate to="/" replace />;
  return children;
};

export default AffiliateOnly;
